import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { TypeHandicap } from 'src/app/shared/models/typeHandicap';
import { Region } from 'src/app/shared/models/region';
import { Service } from 'src/app/shared/models/service';
import { Expertise } from 'src/app/shared/models/expertise';
import { PrestationType } from 'src/app/shared/models/prestation';

@Component({
	selector: 'app-service-modal-detail',
	templateUrl: './service-modal-detail.component.html',
	styleUrls: ['./service-modal-detail.component.scss']
})
export class ServiceModalDetailComponent implements OnInit {
	NAME_PATTERN = '^[^0-9]+$';
	listTypeHandicap : TypeHandicap[];

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required,
		]),
		type: new FormControl(''),
		handleInfosas: new FormControl(),
		typeHandicap: new FormControl(),
		responsable: new FormControl(''),
		cotraitant: new FormControl(),
		mailDiffusion: new FormControl('')
	});

	service: Service;
	listRegion: Region[];
	listExpertise: Expertise[];
	listSelectedRegion: Region[] = [];
	listSelectedExpertises: Expertise[] = [];
	listSelectedExpertiseQD: Expertise[] = [];
	listSelectedExpertiseAC: Expertise[] = [];
	listSelectedExpertiseAS: Expertise[] = [];
	listSelectedExpertiseEAP: Expertise[] = [];
	listSelectedExpertiseCAMEO: Expertise[] = [];
	listSelectedExpertiseSUIVI: Expertise[] = [];
	confirmDeleteModalRef: BsModalRef;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	ngOnInit(): void {
		this.facade.typeHandicapService.getAllTypeHandicaps().subscribe({
			next: (val) => {
				this.listTypeHandicap = val;
			}
		});

		this.facade.regionService.getAllRegion().subscribe({
			next: (val) => {
				this.listRegion = val;
			}
		});

		this.facade.expertiseService.getAllExpertises().subscribe({
			next: (val) => {
				this.listExpertise = val;
			}
		});

		this.listSelectedExpertiseQD = this.service.expertises?.filter((specItfc) => specItfc.typePrestation === PrestationType.QD);
		this.listSelectedExpertiseAS = this.service.expertises?.filter((specItfc) => specItfc.typePrestation === PrestationType.AS);
		this.listSelectedExpertiseAC = this.service.expertises?.filter((specItfc) => specItfc.typePrestation === PrestationType.AC);
		this.listSelectedExpertiseEAP = this.service.expertises?.filter((specItfc) => specItfc.typePrestation === PrestationType.EAP);
		this.listSelectedExpertiseCAMEO = this.service.expertises?.filter((specItfc) => specItfc.typePrestation === PrestationType.CAMEO);
		this.listSelectedExpertiseSUIVI = this.service.expertises?.filter((specItfc) => specItfc.typePrestation === PrestationType.SP);
		this.listSelectedRegion = [...this.service.regions];

		this.formEdit.patchValue({
			name: this.service.name,
			type: this.service.type,
			handleInfosas: this.service.handleInfosas,
			cotraitant: this.service.cotraitant,
			responsable: this.service.responsable,
			typeHandicap: this.service.typeHandicap?.id,
			mailDiffusion: this.service.mailDiffusion,
		});
	}

	isRegionCheck(reg: Region): boolean {
		return this.listSelectedRegion?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedRegion(e: any, reg: Region) {
		if (e.target.checked) {
			if (!this.listSelectedRegion.some((z) => z.id === reg.id)) {
				this.listSelectedRegion.push(reg);
			}
		} else {
			if (this.listSelectedRegion.some((z) => z.id === reg.id)) {
				this.listSelectedRegion = this.listSelectedRegion.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	isExpertiseQDCheck(reg: Expertise): boolean {
		return this.listSelectedExpertiseQD?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedExpertiseQD(e: any, reg: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertiseQD.some((z) => z.id === reg.id)) {
				reg.typePrestation = PrestationType.QD;
				this.listSelectedExpertiseQD.push(reg);
			}
		} else {
			if (this.listSelectedExpertiseQD.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseQD = this.listSelectedExpertiseQD.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	isExpertiseASCheck(reg: Expertise): boolean {
		return this.listSelectedExpertiseAS?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedExpertiseAS(e: any, reg: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertiseAS.some((z) => z.id === reg.id)) {
				reg.typePrestation = PrestationType.AS;
				this.listSelectedExpertiseAS.push(reg);
			}
		} else {
			if (this.listSelectedExpertiseAS.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseAS = this.listSelectedExpertiseAS.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	isExpertiseACCheck(reg: Expertise): boolean {
		return this.listSelectedExpertiseAC?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedExpertiseAC(e: any, reg: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertiseAC.some((z) => z.id === reg.id)) {
				reg.typePrestation = PrestationType.AC;
				this.listSelectedExpertiseAC.push(reg);
			}
		} else {
			if (this.listSelectedExpertiseAC.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseAC = this.listSelectedExpertiseAC.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	isExpertiseEAPCheck(reg: Expertise): boolean {
		return this.listSelectedExpertiseEAP?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedExpertiseEAP(e: any, reg: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertiseEAP.some((z) => z.id === reg.id)) {
				reg.typePrestation = PrestationType.EAP;
				this.listSelectedExpertiseEAP.push(reg);
			}
		} else {
			if (this.listSelectedExpertiseEAP.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseEAP = this.listSelectedExpertiseEAP.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	isExpertiseCAMEOCheck(reg: Expertise): boolean {
		return this.listSelectedExpertiseCAMEO?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedExpertiseCAMEO(e: any, reg: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertiseCAMEO.some((z) => z.id === reg.id)) {
				reg.typePrestation = PrestationType.CAMEO;
				this.listSelectedExpertiseCAMEO.push(reg);
			}
		} else {
			if (this.listSelectedExpertiseCAMEO.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseCAMEO = this.listSelectedExpertiseCAMEO.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	isExpertiseSUIVICheck(reg: Expertise): boolean {
		return this.listSelectedExpertiseSUIVI?.some(
			(specItfc) => specItfc.id === reg.id
		);
	}

	updateSelectedExpertiseSUIVI(e: any, reg: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertiseSUIVI.some((z) => z.id === reg.id)) {
				reg.typePrestation = PrestationType.SP;
				this.listSelectedExpertiseSUIVI.push(reg);
			}
		} else {
			if (this.listSelectedExpertiseSUIVI.some((z) => z.id === reg.id)) {
				this.listSelectedExpertiseSUIVI = this.listSelectedExpertiseSUIVI.filter(
					(z) => z.id !== reg.id
				);
			}
		}
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		this.listSelectedExpertiseQD.forEach(e =>{
			this.listSelectedExpertises.push(new Expertise({id: e.id, typePrestation:PrestationType.QD}))
		})
		this.listSelectedExpertiseAS.forEach(e =>{
			this.listSelectedExpertises.push(new Expertise({id: e.id, typePrestation:PrestationType.AS}))
		})
		this.listSelectedExpertiseAC.forEach(e =>{
			this.listSelectedExpertises.push(new Expertise({id: e.id, typePrestation:PrestationType.AC}))
		})
		this.listSelectedExpertiseEAP.forEach(e =>{
			this.listSelectedExpertises.push(new Expertise({id: e.id, typePrestation:PrestationType.EAP}))
		})
		this.listSelectedExpertiseCAMEO.forEach(e =>{
			this.listSelectedExpertises.push(new Expertise({id: e.id, typePrestation:PrestationType.CAMEO}))
		})
		this.listSelectedExpertiseSUIVI.forEach(e =>{
			this.listSelectedExpertises.push(new Expertise({id: e.id, typePrestation:PrestationType.SP}))
		})
		this.service.regions = this.listSelectedRegion;
		this.service.expertises = this.listSelectedExpertises;
		this.service.name = this.formEdit.get('name').value;
		this.service.type = this.formEdit.get('type').value;
		this.service.handleInfosas = this.formEdit.get('handleInfosas').value;
		this.service.cotraitant = this.formEdit.get('cotraitant').value;
		this.service.responsable = this.formEdit.get('responsable').value;
		this.service.typeHandicap = this.listTypeHandicap.find(x => x.id == this.formEdit.get('typeHandicap').value);
		this.service.mailDiffusion = this.formEdit.get('mailDiffusion').value;
		this.facade.serviceService.updateService(this.service).subscribe({
			next: (succ) => {
				// this.isValidateButtonClicked=false;
				this.bsModalRef.hide();
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
			}
		});
	}

	deleteSpecialty(): void {
		this.facade.serviceService
			.deleteService(this.service.id)
			.subscribe((_) => {
				this.modalService.hide();
				this.bsModalRef.hide();
			});
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	delete() {
		this.facade.serviceService
			.deleteService(this.service.id)
			.subscribe({
				next: (succ) => {
					this.modalService.hide();
					this.bsModalRef.hide();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
				}
			});
	}

	get name() {
		return this.formEdit.get('name');
	}
	get type() {
		return this.formEdit.get('type');
	}
	get handleInfosas() {
		return this.formEdit.get('handleInfosas');
	}
	get responsable() {
		return this.formEdit.get('responsable');
	}
	get typeHandicap() {
		return this.formEdit.get('typeHandicap');
	}
	get cotraitant() {
		return this.formEdit.get('cotraitant');
	}
	get mailDiffusion() {
		return this.formEdit.get('mailDiffusion');
	}
}
